<template>
    <div class="backpage" @click="goBack">
        <!-- <el-icon>
            <Back />
        </el-icon> -->
        ← 返回上一级
    </div>
    <div class="installt">
        <div class="intext">添加员工</div>
    </div>
    <div class="addmesage">
        <div class="addleft">
            <div class="addtop">
                添加员工
            </div>
            <div class="addinp">
                <div class="add">
                    <div>真实姓名</div>
                    <div class="inptext"><input type="text"></div>
                </div>
                <div class="add">
                    <div>账号</div>
                    <div class="inptext"><input type="text"></div>
                </div>
                <div class="add">
                    <div>密码</div>
                    <div class="inptext"><input type="password"></div>
                </div>
                <div class="add">
                    <div>请重新输入密码</div>
                    <div class="inptext"><input type="password"></div>
                </div>

            </div>
            <div class="baocuo">
                保存
            </div>
        </div>
        <div class="addright">
            <div class="addtop">
                选择权限
            </div>
            <div class="gong">
                <div class="guanli">
                    <div class="zong">
                        <div>
                            商品管理
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>

                    </div>
                    <div class="zhongs">
                        <div>
                            商品添加
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            商品删除
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            商品查看
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            商品导出
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            商品审核
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                </div>
                <div class="guanli">
                    <div class="zong">
                        <div>
                            店铺管理
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>

                    </div>
                    <div class="zhongs">
                        <div>
                            店铺添加
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            店铺升级
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            店铺查看
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            店铺封禁
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            店铺审核
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                </div>
                <div class="guanli">
                    <div class="zong">
                        <div>
                            订单管理
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>

                    </div>
                    <div class="zhongs">
                        <div>
                            订单查看
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            订单导出
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            订单发货
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            结束订单
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
              
                </div>
                <div class="guanli">
                    <div class="zong">
                        <div>
                            会员管理
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>

                    </div>
                    <div class="zhongs">
                        <div>
                            会员添加
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            积分充值
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            导出
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            封禁
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            提权
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            冻结
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
                    <div class="zhongs">
                        <div>
                            修改推荐人
                        </div>
                        <div>
                            <el-switch v-model="value" />
                        </div>
                    </div>
              
                </div>

            </div>
        </div>
    </div>
</template>

<script setup>
const goBack = () => {
    window.history.back();
}
</script>

<style lang="scss" scoped>
.backpage {
    margin-top: -20px;
    font-size: 16px;
    color: #3F8CFF;
    cursor: pointer;
}

.installt {
    width: 820px;
    display: flex;
    height: 52px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 36px;
        font-weight: 400;
        color: #0A1629;
    }



}

.addmesage {
    margin-top: 35px;
    height: calc(100% - 52px - 48px);

    .addleft {
        width: 412px;
        height: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        padding: 32px 0 0 35px;
        box-sizing: border-box;
        float: left;
        position: relative;

        .addtop {
            font-size: 18px;

            font-weight: 600;
            color: rgba(0, 0, 0, 0.88);
        }

        .addinp {
            margin-top: 56px;

            margin-left: 14px;

            .add {
                margin-top: 13px;
                font-size: 14px;
                color: #718096;

                .inptext {
                    width: 332px;
                    height: 56px;
                    background: #FAFAFA;
                    padding-left: 10px;
                    box-sizing: border-box;
                    margin-top: 12px;
                    border-radius: 8px;

                    input {
                        font-size: 16px;
                        color: #111827;
                        outline: none;
                        background: transparent;
                        border: none;
                        outline: medium;
                        width: 100%;
                        height: 50px;
                    }
                }
            }

        }

        .baocuo {
            position: absolute;
            width: 96px;
            height: 48px;
            background: #79AFFF;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
            text-align: center;
            line-height: 48px;
            bottom: 50px;
            left: 50%;
            transform: translateX(-50%);
            cursor: pointer;
        }

    }

    .addright {
        width: 728px;
        height: 100%;
        background: #FFFFFF;
        border-radius: 8px;
        margin-left: 24px;
        float: left;
        padding: 32px 0 0 34px;
        box-sizing: border-box;

        .addtop {
            font-size: 18px;

            font-weight: 600;
            color: rgba(0, 0, 0, 0.88);
        }

        .gong {
            margin-top: 11px;
            width: 662px;
            height: 90%;
            overflow: auto;

            &::-webkit-scrollbar {
                width: 8px;
                background-color: rgba(216, 216, 216, 0.2);
            }

            &::-webkit-scrollbar-thumb {
                background: #ccc; // 滑块颜色
            }
            .guanli {
             
                box-sizing: border-box;
                background-color: rgba(216, 216, 216, 0.2);

                .zong {
                    height: 43px;
                    display: flex;
                    padding: 0 23px 0 17px;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 16px;
                    font-weight: 400;
                    color: #111827;
                }

                .zhongs {
                    height: 43px;
                    display: flex;
                    padding: 0 23px 0 33px;
                    align-items: center;
                    justify-content: space-between;
                    background-color: #fff;
                    color: rgba(0, 0, 0, 0.5);
                    font-size: 16px;
                    font-weight: 400;

                }

            }
        }
    }
}
</style>